(() => {
  if (customElements.get('slider-collections')) {
    return;
  }

  class SliderCollections extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.initSwiper = this.initSwiper.bind(this);
    }

    connectedCallback() {
      this.swiperContainer = this.querySelector('.slider__collection-list-swiper');
      this.nextButton = this.querySelector('.slider-collections-button-next');
      this.prevButton = this.querySelector('.slider-collections-button-prev');
      this.pagination = this.querySelector('.slider-collections-pagination');

      if (!this.swiperContainer) {
        return;
      }

      this.initSwiper();
      window.addEventListener('resize', this.initSwiper);
    }

    initSwiper() {
      const isWideScreen = window.innerWidth >= 990;

      if (isWideScreen && !this.swiper) {
        this.swiper = new Swiper(this.swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton
          },
          pagination: {
            el: this.pagination,
            clickable: true
          },
          breakpoints: {
            990: {
              spaceBetween: 24,
              slidesPerView: 4,
            },
          }
        });
      } else if (!isWideScreen && this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.initSwiper);
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    }
  }

  customElements.define('slider-collections', SliderCollections);
})();
